import { useState } from "react";
import { UploadCloud, Send } from "lucide-react";

export default function ContactSupport() {
  const [subject, setSubject] = useState("");
  const [relatedTo, setRelatedTo] = useState("Purchased Deal");
  const [selectedItem, setSelectedItem] = useState("");
  const [screenshot, setScreenshot] = useState(null);

  const handleFileChange = (e) => {
    setScreenshot(e.target.files[0]);
  };

  return (
    <div className="bg-gray-50 min-h-screen flex items-center justify-center px-4 py-8">
      <div className="bg-white max-w-md w-full p-6 rounded shadow-md">
        <h2 className="text-lg font-semibold text-gray-900 mb-1">Contact Support</h2>
        <p className="text-sm text-gray-600 mb-4">
          Please fill out the form below and we’ll get back to you as soon as possible.
        </p>

        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700 mb-1">Subject</label>
          <input
            type="text"
            placeholder="Brief description of your issue"
            value={subject}
            onChange={(e) => setSubject(e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded focus:outline-none focus:ring-1 focus:ring-orange-500"
          />
        </div>

        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700 mb-1">Related To</label>
          <select
            value={relatedTo}
            onChange={(e) => setRelatedTo(e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded focus:outline-none focus:ring-1 focus:ring-orange-500"
          >
            <option>Purchased Deal</option>
            <option>Billing Issue</option>
            <option>Account</option>
          </select>
        </div>

        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700 mb-1">Select Item</label>
          <select
            value={selectedItem}
            onChange={(e) => setSelectedItem(e.target.value)}
            className="w-full px-3 py-2 border border-orange-400 rounded focus:outline-none focus:ring-1 focus:ring-orange-500"
          >
            <option>Select an item</option>
            <option>Premium Yoga Mat Bundle</option>
            <option>Photography Workshop</option>
          </select>
        </div>

        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700 mb-1">Attach Screenshot</label>
          <label className="flex flex-col items-center justify-center border-2 border-dashed border-gray-300 rounded-md px-4 py-6 text-center cursor-pointer text-sm text-gray-600">
            <UploadCloud className="w-6 h-6 mb-2 text-gray-400" />
            <span>
              <span className="text-orange-500 font-medium">Upload a file</span> or drag and drop
            </span>
            <span className="text-xs text-gray-400 mt-1">PNG, JPG up to 10MB</span>
            <input type="file" onChange={handleFileChange} className="hidden" />
          </label>
          {screenshot && (
            <p className="mt-2 text-sm text-gray-700">
              Selected: <span className="font-medium">{screenshot.name}</span>
            </p>
          )}
        </div>

        <button
          type="submit"
          className="w-full bg-orange-500 hover:bg-orange-600 text-white font-medium py-2 px-4 rounded flex items-center justify-center gap-2 transition"
        >
          <Send className="w-4 h-4" />
          Submit Ticket
        </button>
      </div>
    </div>
  );
}
